import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import FeatureSection from './components/FeatureSection';
import OrganizeSection from './components/OrganizeSection';
import BenefitsSection from './components/BenefitsSection';
import DownloadPage from './components/DownloadPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Footer from './components/Footer';
import logo from './assets/mypictor.png';

const appContainerStyle = {
  display: 'grid',
  gridTemplateColumns: '10% 80% 10%',
  minHeight: '100vh',
  width: '100%',
};

const leftColumnStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  paddingTop: 'clamp(7px, 1.8vw, 25px)', // 10% less than original
  paddingRight: 'clamp(11px, 2.7vw, 29px)', // 10% less than original
  paddingBottom: 'clamp(8px, 2vw, 28px)',
  paddingLeft: 'clamp(12px, 3vw, 32px)',
  position: 'sticky',
  top: 0,
  height: 'fit-content',
  zIndex: 100,
};

const centerColumnStyle = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  margin: 0,
  padding: 0,
};

const rightColumnStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  justifyContent: 'flex-start',
  padding: 'clamp(8px, 2vw, 28px) clamp(12px, 3vw, 32px)',
  position: 'sticky',
  top: 0,
  height: 'fit-content',
  zIndex: 100,
};

const logoStyle = {
  height: 'clamp(64px, 10vw, 128px)',
  animation: 'bounce 2s ease-in-out infinite',
};

function App() {
  return (
    <Router>
      <div style={appContainerStyle} className="app-container">
        {/* Left Column - Logo */}
        <div style={leftColumnStyle} className="left-column">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src={logo} alt="MyPictor Logo" style={logoStyle} className="responsive-logo" />
          </Link>
        </div>

        {/* Center Column - Main Content */}
        <div style={centerColumnStyle} className="center-column">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={
                <>
                  <HeroSection />
                  <ProblemSection />
                  <FeatureSection />
                  <OrganizeSection />
                  <BenefitsSection />
                </>
              } />
              <Route path="/download" element={<DownloadPage />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
            </Routes>
          </main>
          <Footer />
        </div>

        {/* Right Column - Empty for now, can add content later */}
        <div style={rightColumnStyle} className="right-column">
        </div>
      </div>
    </Router>
  );
}

export default App;
